import * as actionTypes from './actionTypes';

export const setUser = (image) => {
  return {
    type: actionTypes.SET_USER_IMAGE,
    image: image
  }
};